import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper,
} from "@mui/material";
import { useState } from "react";

import ConfirmationDialog from "../../../../components/dialog/simple-alert";

interface Props {
  openDialog: boolean;
  handleDialogClose(): void;
  handleDialogDelete(): void;
}

export function DeleteRoleForm({
  openDialog,
  handleDialogClose,
  handleDialogDelete,
}: Props): JSX.Element {
  const [dialog, setDialog] = useState(false);

  return (
    <>
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <Paper
          style={{
            width: "400px",
            padding: "15px",
          }}
        >
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this role?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Button
              sx={{ background: "#898989", width: "100%" }}
              variant="contained"
              onClick={handleDialogClose}
            >
              Cancel
            </Button>
            <Button
              sx={{ width: "100%" }}
              variant="contained"
              onClick={() => setDialog(true)}
            >
              Delete
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
      <ConfirmationDialog
        open={dialog}
        title="Confirmation Title"
        message="Are you sure you want to proceed?"
        onConfirm={() => {
          handleDialogDelete();
          setDialog(false);
          handleDialogClose();
        }}
        onCancel={() => {
          setDialog(false);
        }}
      />
    </>
  );
}
